export default __webpack_public_path__ + "media/images/carnival/destination_1_sp-9129104f88a72654d16f394f814daeb5.jpg";